import {initMainHeader} from '../js/src/header-init';
import {replaceLAZoneAbbrNow} from "../js/src/utils";
import '../scss/pages/contact.scss';

initMainHeader();
replaceLAZoneAbbrNow();
